import React from 'react';
import { useLocation } from 'react-router-dom';
import { Icons } from '../Icons/Icons';
import { NavItem } from './NavItem';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../api/users';
import './Navigation.scss';

export const Navigation: React.FC = () => {
  const { logout, userData } = useAuth();
  const location = useLocation();
  const showUsersLink = userData?.role === UserRole.ADMIN || userData?.role === UserRole.DIRECTOR;

  const getNavigationItems = () => {
    if (location.pathname === '/modules' || location.pathname === '/') {
      const moduleItems = [];

      if (userData?.hasMarketingHubAccess) {
        moduleItems.push(
          <NavItem
            key="marketing-hub"
            to="/resources"
            icon={Icons.Resources}
            text="Marketing Hub"
          />
        );
      }

      if (userData?.hasLeaderboardAccess) {
        moduleItems.push(
          <NavItem
            key="leaderboard"
            to="/leaderboard"
            icon={Icons.Leaderboard}
            text="Leaderboard"
          />
        );
      }

      if (showUsersLink) {
        moduleItems.push(<NavItem key="users" to="/users" icon={Icons.Users} text="Users" />);
      }

      return moduleItems;
    }

    const marketingHubRoutes = ['/resources', '/merch', '/events', '/users'];
    const leaderboardRoutes = ['/leaderboard', '/results'];

    const isMarketingHubRoute = marketingHubRoutes.some(
      (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

    if (isMarketingHubRoute) {
      const items = [<NavItem key="modules" to="/modules" icon={Icons.Grid} text="Dashboard" />];

      if (showUsersLink) {
        items.push(<NavItem key="users" to="/users" icon={Icons.Users} text="Users" />);
      }

      items.push(
        <NavItem key="resources" to="/resources" icon={Icons.Resources} text="Resources" />,
        <NavItem key="merch" to="/merch" icon={Icons.Merch} text="Merch" />,
        <NavItem key="events" to="/events" icon={Icons.Events} text="Events" />
      );

      return items;
    }

    const isLeaderboardRoute = leaderboardRoutes.some(
      (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

    if (isLeaderboardRoute) {
      return [
        <NavItem key="modules" to="/modules" icon={Icons.Grid} text="Dashboard" />,
        <NavItem key="leaderboard" to="/leaderboard" icon={Icons.Leaderboard} text="Leaderboard" />,
        <NavItem key="results" to="/results" icon={Icons.Results} text="Results" />,
      ];
    }

    return [<NavItem key="modules" to="/modules" icon={Icons.Grid} text="Modules" />];
  };

  return (
    <nav className="nav">
      <ul>{getNavigationItems()}</ul>
      <button className="logout" onClick={() => logout()}>
        {Icons.Logout}
        <span className="logout-text">Logout</span>
      </button>
    </nav>
  );
};
